/** Best-effort detection of the Tesla in-car browser. */
export function isLikelyTesla(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes('tesla')) return true;
  // Fallback: very wide screen + coarse pointer + landscape (common Tesla heuristic).
  if (typeof window !== 'undefined') {
    const wide = window.matchMedia('(min-width: 1280px)').matches;
    const coarse = window.matchMedia('(pointer: coarse)').matches;
    const landscape = window.matchMedia('(orientation: landscape)').matches;
    if (wide && coarse && landscape) return true;
  }
  return false;
}

/**
 * WebKit (Safari on iOS *and* macOS) treats media with an unresolved
 * `duration` (e.g. Infinity, as our still-synthesizing TTS stream reports)
 * as a "live" stream and locks `playbackRate` at 1× — sometimes even
 * blocking `play()` outright — until duration resolves. Chromium/Gecko
 * don't have this restriction. Detected via `Engine/WebKit` markers rather
 * than device UA strings so it also catches non-Safari WebKit browsers
 * (Brave/Chrome/Firefox on iOS all use WebKit under Apple's policy).
 */
export function isWebKitAudioRateLocked(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  const isWebKit = /AppleWebKit/.test(ua) && !/Chrome|Chromium|Edg\//.test(ua);
  // Covers iPhone/iPod, "desktop-mode" iPadOS (reports as Macintosh + touch),
  // and real macOS — desktop Safari shares the same media engine restriction.
  const isApplePlatform = /iPad|iPhone|iPod|Macintosh/.test(ua);
  return isWebKit && isApplePlatform;
}

export function applyPlatformClasses(): void {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  if (isLikelyTesla()) root.classList.add('platform-tesla');
}
